// Resumo 360 de exemplo enquanto o backend não existe.
//
// Mesmo raciocínio do `journey-clients`: mapa para os clientes do protótipo e
// derivação determinística para o resto da base, de forma que qualquer cliente
// aberto renderize os três cards completos em vez de três caixas vazias.
const PERFIS = ['Conservador', 'Moderado', 'Arrojado']

const TIPOS_REUNIAO = ['Alinhamento', 'Revisão', 'Onboarding']

const RESUMOS_REUNIAO = [
  'Revisão de alocação e ajuste da reserva de emergência.',
  'Apresentação do plano e definição dos objetivos de médio prazo.',
  'Alinhamento sobre sucessão patrimonial e prazos de aporte.',
]

const overview = (clientId, { perfil, patrimonio, aporte, rentabilidade, objetivo, origem, reunioes }) => ({
  clientId,
  perfil,
  objetivo,
  origem,
  patrimonio: {
    total: patrimonio,
    aporteMensal: aporte,
    rentabilidade12m: rentabilidade,
  },
  reunioes,
})

const reuniao = (indice, data) => ({
  tipo: TIPOS_REUNIAO[indice % TIPOS_REUNIAO.length],
  data,
  resumo: RESUMOS_REUNIAO[indice % RESUMOS_REUNIAO.length],
})

const OVERVIEW_MOCK = {
  12401: overview(12401, {
    perfil: 'Moderado',
    patrimonio: 6800000,
    aporte: 60000,
    rentabilidade: 11.8,
    objetivo: 'Sucessão patrimonial e renda passiva de R$ 45 mil por mês',
    origem: 'Indicação — cliente Helena',
    reunioes: [reuniao(0, '2026-07-23'), reuniao(1, '2026-06-11'), reuniao(2, '2026-04-30')],
  }),
}

function derivarPorId(clientId) {
  const n = Math.abs(Number(clientId) || 0)
  return overview(clientId, {
    perfil: PERFIS[n % PERFIS.length],
    patrimonio: 150000 + (n % 40) * 175000,
    aporte: 2000 + (n % 25) * 1500,
    rentabilidade: Number((4 + (n % 90) / 10).toFixed(1)),
    objetivo: 'Crescimento patrimonial com liquidez para o médio prazo',
    origem: n % 2 ? 'Indicação' : 'Prospecção ativa',
    reunioes: [reuniao(n, '2026-07-23'), reuniao(n + 1, '2026-06-11')],
  })
}

export function overviewMockDoCliente(clientId) {
  return OVERVIEW_MOCK[clientId] || derivarPorId(clientId)
}
